import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/auth/guard';

const routes: Routes = [
	{
		path: 'emr',
		loadChildren: () =>
			import('./layout/layout.module').then(m => m.LayoutModule),
		canActivate: [AuthGuard]
	},
	{
		path: 'redirect',
		loadChildren: () =>
			import('./pages/redirect/redirect.module').then(
				m => m.RedirectModule
			)
	},
	{
		path: 'not-found',
		loadChildren: () =>
			import('./pages/not-found/not-found.module').then(
				m => m.NotFoundModule
			)
	},
	{
		path: '**',
		redirectTo: '/not-found',
		pathMatch: 'full'
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			useHash: true,
			scrollPositionRestoration: 'top',
			relativeLinkResolution: 'legacy'
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
